<div class="max-w-md mx-auto mt-10 p-6 bg-white rounded-lg shadow">
  <h2 class="text-2xl font-bold mb-4 text-center">Register</h2>
  <form (submit)="onRegister(); $event.preventDefault()">
    <label class="block mb-2">Username</label>
    <input [(ngModel)]="username" name="username" required class="w-full p-2 border rounded mb-4" />

    <label class="block mb-2">Email</label>
    <input [(ngModel)]="email" name="email" required class="w-full p-2 border rounded mb-4" />

    <label class="block mb-2">Password</label>
    <input type="password" [(ngModel)]="password" name="password" required class="w-full p-2 border rounded mb-4" />

    <button class="w-full bg-green-600 text-white py-2 rounded">Register</button>
    <p class="text-green-500 mt-2 text-center">{{ message }}</p>
    <p class="text-red-500 mt-2 text-center">{{ error }}</p>
  </form>
</div>

